var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"id":"btn","href":"https://github.com/MarcGravel","target":"_blank"}},[_vm._v("View my full Github here")])])}]

export { render, staticRenderFns }